<template>
  <div class="btn-bottom-margin">
    <h1 class="header-style">
      My Documents
    </h1>
    <p class="subheader-style">
      List of documents you have uploaded aganist this organization
    </p>
    <br>
    <organization-documents />
  </div>
</template>
  <script>
  import OrganizationDocuments from '../Components/dialogComponents/organizationsDialogs/OrganizationDocuments.vue';
  export default {
    name: 'OrganizationDocumentsPage',
    components: {
      'organization-documents': OrganizationDocuments,
    },
    data: () => ({
    }),
  };
  </script>
